"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HorizontalAlignment;
(function (HorizontalAlignment) {
    HorizontalAlignment["Left"] = "u-align-left";
    HorizontalAlignment["Center"] = "u-align-center";
    HorizontalAlignment["Right"] = "u-align-right";
    HorizontalAlignment["Justify"] = "u-align-justify";
})(HorizontalAlignment = exports.HorizontalAlignment || (exports.HorizontalAlignment = {}));
;
var VerticalAlignment;
(function (VerticalAlignment) {
    VerticalAlignment["Top"] = "u-align-top";
    VerticalAlignment["Middle"] = "u-align-middle";
    VerticalAlignment["Bottom"] = "u-align-bottom";
    VerticalAlignment["Baseline"] = "u-align-baseline";
})(VerticalAlignment = exports.VerticalAlignment || (exports.VerticalAlignment = {}));
//# sourceMappingURL=Alignment.js.map